import React from 'react'
import { useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { usePermission } from '@tomfxs/permissions-client'
import RouteContainer from 'src/components/App/RouteContainer'

const UserUpdateForm = React.lazy(() => loadComponent('orga', 'UserUpdateForm'))

export function UserDetailsRoute() {
    const params = useParams()

    const canUpdate = usePermission('orga.company.update', {
        user: params._id!,
    })

    return (
        <RouteContainer>
            <UserUpdateForm userId={params._id} canUpdate={canUpdate} />
        </RouteContainer>
    )
}
